import React, { useState } from 'react';
import { FaAngleLeft } from "react-icons/fa6";
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { createOrder } from '../Services/Operations/ProductAPI';

const CashChangePage = () => {
    const token = useSelector((state) => state.user.token);
    const loginData = useSelector((state) => state.user.loginData);
    const location = useLocation();
    const navigation = useNavigate();
    const [cashChangeAmount, setCashChangeAmount] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const { totalAmount,store,products,tipAmount,discountAmount,coupon,payment,orderSuggestion} = location.state || {};

    console.log("totalAmount",totalAmount);
    console.log("store",store);
    console.log("products",products);
    console.log("tipAmount",tipAmount);
    console.log("discountAmount",discountAmount);
    console.log("coupon",coupon);
    console.log("payment",payment);
    console.log("orderSuggestion",orderSuggestion);

    const handleConfirm = async() => {
        const parsedCashChangeAmount = parseFloat(cashChangeAmount);
        const parsedTotalAmount = parseFloat(totalAmount);
        
        console.log("totalAmount cash change page : ", parsedTotalAmount);
        console.log("totalAmount cash change Amount : ", parsedCashChangeAmount);
        
        if (!isNaN(parsedCashChangeAmount) && parsedCashChangeAmount === parsedTotalAmount) {
            // navigation('/success-page');
            const data = {
                "token": token,
                "user": loginData.response,
                "order": products,
                "coupon": coupon,
                "location": {
                    "lat": "22.8765026",
                    "lng": "87.7909507",
                    "address": "Arambag, West Bengal, India",
                    "house": "Test Address",
                    "tag": "Work"
                },
                "order_comment": orderSuggestion,
                "total": {
                    "productQuantity": products.length,
                    "totalPrice": parseFloat(totalAmount)
                },
                "method": payment.name,
                // "delivery_type": 1,
                // "dis": 0.8,
                "tipAmount": tipAmount,
            };
            const raw = JSON.stringify(data);
            try {
                console.log("Data : ",raw)
                const response = await createOrder(raw);
                console.log("order Data:", response);
                if(response.data.success===true){
                    navigation('/success-page');
                }

            } 
            catch (error) {
                console.error("error :", JSON.stringify(error));
            }
        } else {
            setErrorMessage('Please enter the correct amount.');
        }
    };
    

    return (
        <div style={styles.container}>
            <header style={styles.header}>
                <FaAngleLeft onClick={() => navigation(-1)} style={styles.backButton} />
                <div style={{ marginLeft: "18px" }}>
                    <span style={styles.toPayText}>TO PAY</span>
                    <span style={styles.amount}>₹{totalAmount}</span>
                </div>
            </header>

            <div style={styles.content}>
                <h3 style={styles.instructionText}>Enter cash change amount</h3>

                <input
                    type="number"
                    value={cashChangeAmount}
                    onChange={(e) => {
                        setCashChangeAmount(e.target.value);
                        setErrorMessage(''); 
                    }}
                    placeholder="Enter amount"
                    style={styles.inputField}
                />

                {errorMessage && <p style={styles.errorText}>{errorMessage}</p>}

                <button style={styles.confirmButton} onClick={handleConfirm}>
                    CONFIRM
                </button>

                <p style={styles.noteText}>
                    Leave the field empty if you don't require any cash change for Cash On Delivery of your order.
                </p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        fontFamily: 'Arial, sans-serif',
        padding: '20px',
        backgroundColor: '#fff',
        height: '100vh',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px solid #ccc',
        paddingBottom: '10px',
        marginBottom: '20px',
    },
    backButton: {
        fontSize: '24px',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
    },
    toPayText: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    amount: {
        fontSize: '18px',
        color: 'orange',
        fontWeight: 'bold',
    },
    content: {
        textAlign: 'center',
    },
    instructionText: {
        fontSize: '16px',
        marginBottom: '20px',
    },
    inputField: {
        width: '80%',
        padding: '10px',
        fontSize: '18px',
        borderRadius: '5px',
        marginBottom: '10px',
        outline:"none",
        border:"none",
        boxShadow:"box-shadow: rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px;"
    },
    confirmButton: {
        marginTop: "27px",
        border: "none",
        outline: "none",
        backgroundColor: '#4CAF50',
        color: '#fff',
        padding: '10px 20px',
        fontSize: '18px',
        border: '1px solid black',
        borderRadius: '5px',
        cursor: 'pointer',
        marginBottom: '20px',
    },
    errorText: {
        color: 'red',
        fontSize: '14px',
        marginBottom: '10px',
    },
    noteText: {
        fontSize: '14px',
        color: '#777',
    },
};

export default CashChangePage;
